var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 531.627,
    height: 496.954,
    viewBox: "0 0 531.627 496.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10868",
    "data-name": "Rectangle 10868",
    width: 531.627,
    height: 496.954,
    transform: "translate(35.948 0)",
    fill: "none",
    stroke: "#d2eafc",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4363",
    "data-name": "Group 4363",
    transform: "translate(-35.948 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4362",
    "data-name": "Group 4362",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_329",
    "data-name": "Line 329",
    x1: 35.447,
    y2: 35.447,
    transform: "translate(0.501 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_330",
    "data-name": "Line 330",
    x1: 496.285,
    y1: 496.285,
    transform: "translate(0.502 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_331",
    "data-name": "Line 331",
    x2: 602.594,
    transform: "translate(0.501 18.427)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    x1: 460.816,
    y1: 460.816,
    transform: "translate(0.501 36.15)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    x2: 602.594,
    transform: "translate(0.501 53.874)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_334",
    "data-name": "Line 334",
    x1: 425.372,
    y1: 425.372,
    transform: "translate(0.501 71.597)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_335",
    "data-name": "Line 335",
    x2: 602.594,
    transform: "translate(0.501 89.32)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_336",
    "data-name": "Line 336",
    x1: 389.925,
    y1: 389.925,
    transform: "translate(0.501 107.044)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_337",
    "data-name": "Line 337",
    x2: 602.594,
    transform: "translate(0.501 124.767)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_338",
    "data-name": "Line 338",
    x1: 354.473,
    y1: 354.473,
    transform: "translate(0.501 142.491)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_339",
    "data-name": "Line 339",
    x2: 602.594,
    transform: "translate(0.501 160.214)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_340",
    "data-name": "Line 340",
    x1: 319.025,
    y1: 319.025,
    transform: "translate(0.502 177.939)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_341",
    "data-name": "Line 341",
    x2: 602.594,
    transform: "translate(0.501 195.661)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342",
    "data-name": "Line 342",
    x1: 283.578,
    y1: 283.578,
    transform: "translate(0.501 213.385)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343",
    "data-name": "Line 343",
    x2: 602.594,
    transform: "translate(0.501 231.108)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344",
    "data-name": "Line 344",
    x1: 248.13,
    y1: 248.13,
    transform: "translate(0.502 248.832)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345",
    "data-name": "Line 345",
    x2: 602.594,
    transform: "translate(0.501 266.555)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346",
    "data-name": "Line 346",
    x1: 212.688,
    y1: 212.688,
    transform: "translate(0.501 284.279)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347",
    "data-name": "Line 347",
    x2: 602.594,
    transform: "translate(0.501 302.002)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348",
    "data-name": "Line 348",
    x1: 177.311,
    y1: 177.312,
    transform: "translate(0.502 319.725)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349",
    "data-name": "Line 349",
    x2: 602.594,
    transform: "translate(0.501 337.449)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350",
    "data-name": "Line 350",
    x1: 141.786,
    y1: 141.786,
    transform: "translate(0.501 355.173)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351",
    "data-name": "Line 351",
    x2: 602.594,
    transform: "translate(0.501 372.896)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352",
    "data-name": "Line 352",
    x1: 106.339,
    y1: 106.339,
    transform: "translate(0.501 390.62)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353",
    "data-name": "Line 353",
    x2: 602.594,
    transform: "translate(0.501 408.343)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354",
    "data-name": "Line 354",
    x1: 70.893,
    y1: 70.893,
    transform: "translate(0.501 426.066)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x1: 35.447,
    y1: 35.447,
    transform: "translate(0.543 461.471)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356",
    "data-name": "Line 356",
    x2: 602.594,
    transform: "translate(0.501 443.79)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    x2: 602.594,
    transform: "translate(0.501 479.195)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358",
    "data-name": "Line 358",
    y1: 496.249,
    transform: "translate(35.874 0.708)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359",
    "data-name": "Line 359",
    y1: 496.249,
    transform: "translate(53.523 0.708)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360",
    "data-name": "Line 360",
    y1: 496.249,
    transform: "translate(71.172 0.708)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361",
    "data-name": "Line 361",
    x1: 70.894,
    y2: 70.894,
    transform: "translate(0.501 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_362",
    "data-name": "Line 362",
    x1: 496.264,
    y1: 496.264,
    transform: "translate(35.948 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363",
    "data-name": "Line 363",
    x1: 106.341,
    y2: 106.341,
    transform: "translate(0.501 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_364",
    "data-name": "Line 364",
    x1: 496.403,
    y1: 496.403,
    transform: "translate(71.395 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_365",
    "data-name": "Line 365",
    y1: 496.249,
    transform: "translate(89.118 0.707)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_366",
    "data-name": "Line 366",
    y1: 496.249,
    transform: "translate(106.767 0.707)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_367",
    "data-name": "Line 367",
    y1: 496.249,
    transform: "translate(124.416 0.707)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_368",
    "data-name": "Line 368",
    y1: 496.249,
    transform: "translate(142.066 0.707)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_369",
    "data-name": "Line 369",
    y1: 496.249,
    transform: "translate(159.715 0.707)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_370",
    "data-name": "Line 370",
    x1: 141.787,
    y2: 141.787,
    transform: "translate(0.501 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_371",
    "data-name": "Line 371",
    x1: 496.265,
    y1: 496.265,
    transform: "translate(106.842 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_372",
    "data-name": "Line 372",
    x1: 177.234,
    y2: 177.234,
    transform: "translate(0.501 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_373",
    "data-name": "Line 373",
    x1: 460.942,
    y1: 460.942,
    transform: "translate(142.288 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_374",
    "data-name": "Line 374",
    y1: 496.249,
    transform: "translate(160.011 0.707)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_375",
    "data-name": "Line 375",
    x1: 212.681,
    y2: 212.681,
    transform: "translate(0.501 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_376",
    "data-name": "Line 376",
    x1: 425.484,
    y1: 425.484,
    transform: "translate(177.735 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_377",
    "data-name": "Line 377",
    y1: 496.249,
    transform: "translate(195.458 0.706)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_378",
    "data-name": "Line 378",
    y1: 496.249,
    transform: "translate(177.365 0.707)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_379",
    "data-name": "Line 379",
    y1: 496.249,
    transform: "translate(213.107 0.706)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_380",
    "data-name": "Line 380",
    x1: 248.128,
    y2: 248.128,
    transform: "translate(0.5 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_381",
    "data-name": "Line 381",
    x1: 390.026,
    y1: 390.026,
    transform: "translate(213.182 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_382",
    "data-name": "Line 382",
    y1: 496.249,
    transform: "translate(230.905 0.706)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_383",
    "data-name": "Line 383",
    y1: 496.249,
    transform: "translate(248.554 0.706)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_384",
    "data-name": "Line 384",
    y1: 496.249,
    transform: "translate(266.203 0.706)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_385",
    "data-name": "Line 385",
    y1: 496.249,
    transform: "translate(283.853 0.706)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_386",
    "data-name": "Line 386",
    x1: 283.575,
    y2: 283.575,
    transform: "translate(0.5 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_387",
    "data-name": "Line 387",
    x1: 354.568,
    y1: 354.568,
    transform: "translate(248.628 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_388",
    "data-name": "Line 388",
    x1: 319.022,
    y2: 319.022,
    transform: "translate(0.5 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_389",
    "data-name": "Line 389",
    x1: 319.11,
    y1: 319.11,
    transform: "translate(284.075 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_390",
    "data-name": "Line 390",
    y1: 496.249,
    transform: "translate(301.798 0.706)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_391",
    "data-name": "Line 391",
    y1: 496.249,
    transform: "translate(319.448 0.706)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_392",
    "data-name": "Line 392",
    x1: 354.469,
    y2: 354.469,
    transform: "translate(0.5 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_393",
    "data-name": "Line 393",
    x1: 283.654,
    y1: 283.654,
    transform: "translate(319.521 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_394",
    "data-name": "Line 394",
    y1: 496.249,
    transform: "translate(337.245 0.705)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_395",
    "data-name": "Line 395",
    y1: 496.249,
    transform: "translate(354.894 0.705)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_396",
    "data-name": "Line 396",
    x1: 389.915,
    y2: 389.915,
    transform: "translate(0.5 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_397",
    "data-name": "Line 397",
    x1: 248.6,
    y1: 248.6,
    transform: "translate(354.968 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_398",
    "data-name": "Line 398",
    y1: 496.249,
    transform: "translate(372.692 0.705)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_399",
    "data-name": "Line 399",
    y1: 496.249,
    transform: "translate(390.341 0.705)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_400",
    "data-name": "Line 400",
    x1: 425.362,
    y2: 425.362,
    transform: "translate(0.5 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_401",
    "data-name": "Line 401",
    x1: 212.736,
    y1: 212.736,
    transform: "translate(390.416 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_402",
    "data-name": "Line 402",
    y1: 496.249,
    transform: "translate(408.138 0.704)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_403",
    "data-name": "Line 403",
    y1: 496.249,
    transform: "translate(425.788 0.704)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_404",
    "data-name": "Line 404",
    x1: 460.807,
    y2: 460.807,
    transform: "translate(0.502 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_405",
    "data-name": "Line 405",
    x1: 177.548,
    y1: 177.548,
    transform: "translate(425.863 0.704)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_406",
    "data-name": "Line 406",
    y1: 496.249,
    transform: "translate(443.585 0.704)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_407",
    "data-name": "Line 407",
    y1: 496.249,
    transform: "translate(461.234 0.704)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_408",
    "data-name": "Line 408",
    x1: 496.254,
    y2: 496.254,
    transform: "translate(0.502 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_409",
    "data-name": "Line 409",
    x1: 142.023,
    y1: 142.023,
    transform: "translate(461.309 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_410",
    "data-name": "Line 410",
    y1: 496.249,
    transform: "translate(479.032 0.704)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_411",
    "data-name": "Line 411",
    y1: 496.249,
    transform: "translate(496.681 0.704)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_412",
    "data-name": "Line 412",
    x1: 496.185,
    y2: 496.185,
    transform: "translate(36.017 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_413",
    "data-name": "Line 413",
    x1: 106.493,
    y1: 106.493,
    transform: "translate(496.756 0.704)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_414",
    "data-name": "Line 414",
    y1: 496.249,
    transform: "translate(514.479 0.704)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_415",
    "data-name": "Line 415",
    y1: 496.249,
    transform: "translate(532.128 0.704)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_416",
    "data-name": "Line 416",
    x1: 496.253,
    y2: 496.253,
    transform: "translate(71.396 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_417",
    "data-name": "Line 417",
    x1: 70.972,
    y1: 70.972,
    transform: "translate(532.203 0.704)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_418",
    "data-name": "Line 418",
    y1: 496.249,
    transform: "translate(549.925 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_419",
    "data-name": "Line 419",
    y1: 496.249,
    transform: "translate(567.575 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_420",
    "data-name": "Line 420",
    x1: 496.253,
    y2: 496.253,
    transform: "translate(106.843 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_421",
    "data-name": "Line 421",
    x1: 460.805,
    y2: 460.805,
    transform: "translate(142.291 36.15)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_422",
    "data-name": "Line 422",
    x1: 425.278,
    y2: 425.278,
    transform: "translate(177.818 71.754)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_423",
    "data-name": "Line 423",
    x1: 389.907,
    y2: 389.598,
    transform: "translate(213.188 107.358)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_424",
    "data-name": "Line 424",
    x1: 354.459,
    y2: 353.994,
    transform: "translate(248.636 142.963)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_425",
    "data-name": "Line 425",
    x1: 319.011,
    y2: 318.39,
    transform: "translate(284.084 178.567)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_426",
    "data-name": "Line 426",
    x1: 283.585,
    y2: 283.484,
    transform: "translate(319.533 213.473)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_427",
    "data-name": "Line 427",
    x1: 248.115,
    y2: 247.181,
    transform: "translate(354.981 249.775)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_428",
    "data-name": "Line 428",
    x1: 212.689,
    y2: 212.546,
    transform: "translate(390.431 284.412)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_429",
    "data-name": "Line 429",
    x1: 177.241,
    y2: 177.077,
    transform: "translate(425.877 319.88)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_430",
    "data-name": "Line 430",
    x1: 141.792,
    y2: 141.608,
    transform: "translate(461.326 355.349)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_431",
    "data-name": "Line 431",
    x1: 106.344,
    y2: 106.139,
    transform: "translate(496.774 390.819)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_432",
    "data-name": "Line 432",
    x1: 70.896,
    y2: 70.67,
    transform: "translate(532.222 426.288)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_433",
    "data-name": "Line 433",
    x1: 35.426,
    y2: 34.583,
    transform: "translate(567.67 462.374)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_434",
    "data-name": "Line 434",
    x1: 35.447,
    y1: 35.447,
    transform: "translate(567.649 0.703)",
    fill: "none",
    stroke: "#d2eafc",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.b58369b18c9f70ac4457c0e3f3efb4c2.svg";
export { ForwardRef as ReactComponent };